<template>
  <div :id='randomId' class='h-topo-treebox h-topo-tree h-track-list' >
    <ejs-listview id='flat-list' ref="listNeNoIP" :dataSource='data' :filterCode="typeCode"></ejs-listview>
  </div>
</template>

<script>
import { EventBus } from '../../plugins/eventBus.js';
export default {
  name: 'NeListNoIP',
  props: [
    'neArr',
    'select',
    'keywords',
    'typeCode',
  ],
  data() {
    return {
      data: [],
      primaryDatas: [],
      $formId: '',
      qrySubSliceList:[],
    };
  },
  computed: {
    randomId() {
      const _temp = 'abcdefghijklmnopqrstuvwxyz';
      this.$formId = '';
      for (let i = 0; i < 5; i++) {
        this.$formId += _temp[Math.round(Math.random(1) * 26)];
      }
      return this.$formId;
    }
  },
  methods: {
    _getNeTreeData() {
      const $this = this;
      $this.data = [];
      this.$axios.post('/lte/ems/auth/findElementListByAuth', this.neArr).then((response) => {
        const _nodeArray = response.data;
        const showData = [];
        const showPrimaryDatas = [];
        _nodeArray.forEach((_item) => {
          const { id, name, equipmentIPId, typeCode, equipmentTypeCode, physicalIP} = _item;
          let nssiName='';
          if(36==this.neArr){//目前只有UDM前缀展示子网实例名称
          for(let i=0;i<this.qrySubSliceList.length;i++){
            if(id==this.qrySubSliceList[i].neConfig){
              nssiName=this.qrySubSliceList[i].name;
            }
          }
          }
          const _dataItem = {
            text: nssiName==''?`${name}`:`${nssiName}-${name}`,
            id,
            neType: typeCode,
            typeCode: equipmentTypeCode,
            tooltip: nssiName==''?`${name}`:`${nssiName}-${name}`,
            equipmentIPId
          };
          if (($this.typeCode && _dataItem.typeCode !== 10006) || $this.typeCode === undefined) {
            showData.push(_dataItem);
            showPrimaryDatas.push(_dataItem);
          }
        });
        $this.data = showData;
        $this.primaryDatas = showPrimaryDatas;
      });
    },
    doSearch() {
      if (this.keywords === '') {
        this.data = this.primaryDatas;
        return;
      }
      const leftNeDatas = this.primaryDatas.filter(neData => (neData.text.includes(this.keywords)));
      this.data = leftNeDatas;
    },
    getNe() {
      return this.$refs.listNeNoIP.getSelectedItems();
    },
    getOnlineNe() {
      const $this = this;
      const node = $this.$refs.listNeNoIP.getSelectedItems();
      $this.axios.get(`/lte/ems/config/mml/queryNodeLinkStatus/${node.data.id}`).then(res => {
        const nodeStatus = res.data ? res.data.resultVal : 0;
        if (nodeStatus === 0) {
          EventBus.$emit('toast', { type: 'warning', content: $this.$t('Common.neOffLine', [node.data.text]) });
        }
      });
      return node;
    },
    getNssiName() {
      if(36==this.neArr){
      this.axios.post(`/lte/ems/networkSlice/qrySubSlice/${this.neArr}`).then(response => {
        if (response &&response.status === 200 &&response.data.errorCode === "SUCCESS"){
          this.qrySubSliceList=response.data.resultVal;
          }
      });
    }
    }
  },
  beforeMount() {
    this.getNssiName();
    this._getNeTreeData();
  },
  updated() {
    const $this = this;
    document.getElementById(this.$formId).onclick = function () {
      $this.select();
    };
  }
};

</script>

<style scoped>

</style>
